import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { Input, AutoComplete, message, Button, Form } from "antd";
import axios from "axios";

import {
  COLLABORATORS_QUERY,
  INVITE_COLLABORATOR_MUTATION,
} from "../../helpers/graphql/collaborator";

interface Props {
  project: { id: string };
}

interface inviteFormInputValues {
  githubId: string;
}

export function InviteCollaborator({ project }: Props) {
  const [options, setOptions] = useState<{ value: string }[]>([]);

  const [inviteCollaborator, { loading: inviteLoading }] = useMutation(
    INVITE_COLLABORATOR_MUTATION,
    {
      onCompleted: () => {
        message.success("Invited collaborator!");
      },
      refetchQueries: () => [
        {
          query: COLLABORATORS_QUERY,
          variables: {
            projectId: project.id,
          },
        },
      ],
    },
  );

  const renderOptions = (login: string, avatar_url: string) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {login}
        <span>
          <img alt={"icon"} src={avatar_url} style={{ height: 20 }} />
        </span>
      </div>
    );
  };

  let delayTimer: any;
  const onSearch = (searchText: string) => {
    clearTimeout(delayTimer);
    if (!searchText) {
      setOptions([]);
    } else {
      delayTimer = setTimeout(async function () {
        axios.get(`https://api.github.com/search/users?q=${searchText}+in:login`).then((result) => {
          result.data.items.map((_: any) => {
            _.label = renderOptions(_.login, _.avatar_url);
            _.value = _.login;
            return _;
          });
          setOptions(result.data.items || []);
        });
      }, 2000);
    }
  };

  const handleSubmit = async (values: inviteFormInputValues) => {
    clearTimeout(delayTimer);
    inviteCollaborator({
      variables: {
        email: `${values.githubId}@users.noreply.github.com`,
        githubId: values.githubId,
        projectId: project.id,
      },
    });
  };

  return (
    <>
      <Form<inviteFormInputValues>
        id="inviteForm"
        name="inviteForm"
        layout="inline"
        labelCol={{ span: 10 }}
        wrapperCol={{ span: 100 }}
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Form.Item name="githubId">
          <AutoComplete
            options={options}
            style={{ width: "30vw" }}
            onSelect={() => {}}
            onSearch={onSearch}
          >
            <Input placeholder="Search by Github ID" />
          </AutoComplete>
        </Form.Item>
        <Form.Item>
          <Button
            form="inviteForm"
            key="submit"
            htmlType="submit"
            type="primary"
            loading={inviteLoading}
          >
            Invite
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
